import React from 'react';

export const EnterpriseAdvisory: React.FC<{color: string}> = ({color}) => (
  <svg width="110" height="77" viewBox="0 0 110 77" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.3">
      <ellipse cx="66.1396" cy="18.5147" rx="10.706" ry="10.5148" fill="#DCF15B" />
      <path
        d="M83.3456 45.0885C83.3456 55.2246 75.6422 45.0885 66.1396 45.0885C56.637 45.0885 48.9336 55.2246 48.9336 45.0885C48.9336 34.9523 56.637 26.7354 66.1396 26.7354C75.6422 26.7354 83.3456 34.9523 83.3456 45.0885Z"
        fill="#DCF15B"
      />
    </g>
    <g opacity="0.6">
      <ellipse cx="92.3876" cy="28.7623" rx="10.706" ry="10.5148" fill="#DCF15B" />
      <path
        d="M109.594 55.3361C109.594 65.4723 101.89 55.3361 92.3877 55.3361C82.885 55.3361 75.1816 65.4723 75.1816 55.3361C75.1816 45.2 82.885 36.9831 92.3877 36.9831C101.89 36.9831 109.594 45.2 109.594 55.3361Z"
        fill="#DCF15B"
      />
    </g>
    <ellipse cx="29.717" cy="18.6601" rx="18.4904" ry="18.1602" fill="#CFCAAC" />
    <path
      d="M59.4334 64.5559C59.4334 82.0621 46.1288 64.5559 29.7167 64.5559C13.3046 64.5559 0 82.0621 0 64.5559C0 47.0497 13.3046 32.8581 29.7167 32.8581C46.1288 32.8581 59.4334 47.0497 59.4334 64.5559Z"
      fill="#CFCAAC"
    />
    <ellipse cx="71.6312" cy="39.2457" rx="12.723" ry="12.4958" fill="#DCF15B" />
    <path
      d="M92.079 70.8261C92.079 82.8719 82.9243 70.8261 71.6313 70.8261C60.3384 70.8261 51.1836 82.8719 51.1836 70.8261C51.1836 58.7803 60.3384 49.0152 71.6313 49.0152C82.9243 49.0152 92.079 58.7803 92.079 70.8261Z"
      fill="#DCF15B"
    />
  </svg>
);

export const EnterpriseCoaching: React.FC<{color: string}> = ({color}) => (
  <svg width="168" height="86" viewBox="0 0 168 86" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="114.09" height="47.844" rx="23.922" transform="matrix(-1 0 0 1 167.955 14.8639)" fill="#DCF15B" />
    <path
      d="M136.761 50.3294L151.541 61.1878C146.513 62.6242 138.972 66.5743 125.623 79.3086C133.735 62.2302 132.924 57.456 128.389 48.891L136.761 50.3294Z"
      fill="#DCF15B"
    />
    <rect y="0.5" width="114.194" height="28.0098" rx="14.0049" fill="#CFCAAC" />
    <path
      d="M31.1943 15.8558L16.4143 26.7142C21.4417 28.1506 28.9827 32.1006 42.3318 44.8349C34.2203 27.7565 35.0316 22.9823 39.5665 14.4174L31.1943 15.8558Z"
      fill="#CFCAAC"
    />
  </svg>
);

export const EnterpriseEducation: React.FC<{color: string}> = ({color}) => (
  <svg width="104" height="81" viewBox="0 0 104 81" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 21.4196C0 16.7936 4.14707 13.2705 8.7123 14.0182L45.6885 20.0747C49.3144 20.6686 51.9762 23.8018 51.9762 27.4761V72.005C51.9762 76.4269 48.1703 79.889 43.7682 79.4715L6.79197 75.9652C2.94139 75.6 0 72.3665 0 68.4987V21.4196Z"
      fill="#DCF15B"
    />
    <path
      d="M103.952 21.4196C103.952 16.7936 99.8051 13.2705 95.2399 14.0182L58.2637 20.0747C54.6377 20.6686 51.976 23.8018 51.976 27.4761V72.005C51.976 76.4269 55.7819 79.889 60.184 79.4715L97.1602 75.9652C101.011 75.6 103.952 72.3665 103.952 68.4987V21.4196Z"
      fill="#DCF15B"
    />
    <path
      d="M6.66992 9.19165C6.66992 4.44465 11.0243 0.891706 15.6748 1.84417L45.9808 8.0512C49.4704 8.76592 51.976 11.8366 51.976 15.3987V65.3032C51.976 69.7954 48.0538 73.28 43.5928 72.751L13.2868 69.1575C9.51271 68.71 6.66992 65.5102 6.66992 61.7097V9.19165Z"
      fill="#CFCAAC"
    />
    <path
      d="M97.2822 9.19165C97.2822 4.44465 92.9278 0.891706 88.2774 1.84417L57.9714 8.0512C54.4817 8.76592 51.9762 11.8366 51.9762 15.3987V65.3032C51.9762 69.7954 55.8984 73.28 60.3593 72.751L90.6654 69.1575C94.4394 68.71 97.2822 65.5102 97.2822 61.7097V9.19165Z"
      fill="#CFCAAC"
    />
  </svg>
);
